<template>
  <div>
    <!-- 单个菜单 -->
    <template v-if="!hasChildren(data)">
      <app-link v-if="hasShow(data)" :to="data.link">
        <el-menu-item
          :index="childIndex"
          class="submenu-title-noDropdown"
          :class="{'is-first-active': isActive(data, childIndex)}"
        >
          <div class="submenu-box">
            <item icon="icon-caidan" :title="menuName" />
          </div>
        </el-menu-item>
      </app-link>
    </template>
    <!-- 可展开菜单 -->
    <el-submenu
      v-else
      :index="childIndex"
      class="yld-sub-menu"
      popper-append-to-body
      style="min-width:260px"
    >
      <template slot="title">
        <item icon="icon-caidan" :title="menuName" />
      </template>
      <template
        v-for="(child, key) in data.childNode"
      >
        <app-link
          v-if="hasShow(child)"
          :key="child.id"
          :to="child.link"
          :class="{'is-first-active': isActive(child, `${childIndex}-${key}`)}"
        >
          <el-menu-item
            :index="`${childIndex}-${key}`"
            class="submenu-title-noDropdown"
          >
            {{ formatMenu(child) }}
          </el-menu-item>
        </app-link>
      </template>
    </el-submenu>
  </div>
</template>
<script>
import Item from './Item.vue'
import AppLink from './Link.vue'

export default {
  name: 'SecondMenu',
  components: {
    Item,
    AppLink
  },
  props: {
    data: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    },
    childIndex: {
      type: String,
      default: '  '
    },
    currentPath: {
      type: String,
      default: ''
    }
  },
  computed: {
    dataList() {
      return this.data
    },
    menuName() {
      return this.data.menuName
    }
  },
  methods: {
    hasChildren(data) {
      const childNode = data.childNode || []
      const showChildren = childNode.filter(v => {
        if (v.menuType === 2) {
          return false
        } else {
          return true
        }
      })
      if (showChildren.length === 1) {
        return true
      }
      if (showChildren.length === 0) {
        return false
      }
      return true
    },
    hasShow(data) {
      const menuType = data.menuType
      if (menuType !== 2) {
        return true
      } else {
        return false
      }
    },
    isActive(val, index) {
      if (this.currentPath.includes(val.link)) {
        this.$emit('updateActiveIndex', index)
        return true
      } else {
        return false
      }
    },
    formatMenu(keys) {
      // 员工管理
      if (keys.menuKey === 'rms_user_list') {
        return this.$t('msg.employeeManagementMenu')
      }
      // 分公司管理
      if (keys.menuKey === 'rms_branch_list') {
        return this.$t('msg.branchManagementMenu')
      }
      // 角色权限管理
      if (keys.menuKey === 'rms_role_list') {
        return this.$t('msg.rolePermissionManagementMenu')
      }
      // 部门权限管理
      if (keys.menuKey === 'rms_role_depart') {
        return this.$t('msg.departmentAuthorityManagementMenu')
      }
    }
  }
}
</script>
<style lang="scss">
</style>
